module.exports = __webpack_public_path__ + "img/img_map_no_data.c129bcff.png";